import Policy from '@/pages/Policy'

export default {
    path: '/policy',
    name: 'Policy',
    component: Policy
}


// WEBPACK FOOTER //
// ./src/router/policy.js